import React, { Component } from 'react'
// components
import CircleBackground from 'components/common/CircleBackground'
import SquareBackground from 'components/common/SquareBackground'
import Input from 'components/Form/Input'
import CheckBox from 'components/Form/CheckBox'
import { OldButton } from 'components/Button'
import { FieldInput } from 'components/Form/Fields/FieldInput'
import { FieldCheckBox } from 'components/Form/Fields/FieldCheckBox'
import { icons } from './icons'
import { FieldSelect } from 'components/Form/Fields/FieldSelect'
import Select from 'components/Form/Select'
// redux
import { compose } from 'redux'
import { InjectedFormProps, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { push, Push } from 'connected-react-router'
import { stateRouter } from 'domain/router/reducer'
import * as A from 'domain/env'
import { jobsFavoriteSelector } from 'domain/guestJobs'
import { modalIsLoadingSelector } from 'domain/loading'
// types
import { ButtonHtmlTypes, ButtonTypes, ComposeType } from 'types/common'
import { Classes } from 'jss'
import cx from 'classnames'
import { StateInterface } from 'types/state'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
// utils
import { signUpValidate } from 'pages/Auth/validation'
import { upper } from 'lib/normalize'
import BackgroundWithFigures from 'components/common/BackgroundWithFigures'
import SignUpRadio from './components/SignUpRadio'
import { StateSignUp } from './types'
import { Button } from 'components/ui/Button'

interface FormValuesInterface {
  firstName: string
  lastName: string
  email: string
  password: string
  confirmationPassword: string
  accept: boolean
  campaign?: string
  favoriteJobs?: number[]
  country?: string
}

const radiobtns = [
  {
    value: StateSignUp.Candidate,
    title: 'Find a Job',
    subtitle: 'Search and apply for an opportunity that matches your skills'
  },
  {
    value: StateSignUp.Recruiter,
    title: 'Recruit Talent',
    subtitle: 'Find and connect with qualified candidates '
  },
  {
    value: StateSignUp.Manager,
    title: 'Hire for my team',
    subtitle: 'Manage hiring processes and build great teams'
  }
]

interface SignUpLocationState {
  isCandidate?: boolean
  role?: StateSignUp
}

const getSelectedOptionFromLocation = (stateFromLocation?: SignUpLocationState): StateSignUp => {
  if (stateFromLocation && stateFromLocation.role) {
    return stateFromLocation.role
  }

  if (stateFromLocation && typeof stateFromLocation.isCandidate === 'boolean') {
    return stateFromLocation.isCandidate ? StateSignUp.Candidate : StateSignUp.Manager
  }

  return StateSignUp.Candidate
}

interface OwnProps {
  classes: Classes
  signUpManager: (data: FormValuesInterface) => void
  signUpRecruiter: (data: FormValuesInterface) => void
  signUpCandidate: (data: FormValuesInterface) => void
  push?: Push
  stateFromLocation?: SignUpLocationState
  favoriteJobs?: number[]
  modalIsLoading: boolean
}

interface State {
  selectedOption: StateSignUp
  isSubmitting: boolean
}

type Props = InjectedFormProps<FormValuesInterface> & OwnProps

class SignUp extends Component<Props, State> {
  state = {
    selectedOption: getSelectedOptionFromLocation(this.props.stateFromLocation),
    isSubmitting: false
  }

  componentDidUpdate(prevProps: Props) {
    const prevRole = prevProps.stateFromLocation && prevProps.stateFromLocation.role
    const nextRole = this.props && this.props.stateFromLocation && this.props.stateFromLocation.role
    const prevIsCandidate = prevProps.stateFromLocation && prevProps.stateFromLocation.isCandidate
    const nextIsCandidate =
      this.props && this.props.stateFromLocation && this.props.stateFromLocation.isCandidate

    if (prevRole !== nextRole || prevIsCandidate !== nextIsCandidate) {
      const selectedOption = getSelectedOptionFromLocation(this.props.stateFromLocation)

      if (selectedOption !== this.state.selectedOption) {
        this.setState({ selectedOption })
      }
    }
  }

  onClick = (path: string) => {
    if (this.props.push) this.props.push(path)
  }

  changeSelectedOption = (value: StateSignUp) => {
    this.setState(prevState => ({
      ...prevState,
      selectedOption: value
    }))
  }

  submit = (data: FormValuesInterface) => {
    switch (this.state.selectedOption) {
      case StateSignUp.Manager:
        this.props.signUpManager(data)
        break
      case StateSignUp.Recruiter:
        this.props.signUpRecruiter(data)
        break
      default:
        const { favoriteJobs } = this.props
        this.props.signUpCandidate({ ...data, favoriteJobs })
        break
    }
  }

  logIn = () => {
    this.onClick('/log-in')
  }

  render() {
    const { classes, handleSubmit, modalIsLoading } = this.props
    const { selectedOption } = this.state
    const countryOptions = [
      { value: 'india', label: 'India' },
      { value: 'united states', label: 'USA' }
    ]

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className={classes.content}>
          <div className={`d-flex column  ${classes.textLeft}`}>
            <BackgroundWithFigures />
            <div className={`${classes.topBlock} d-flex column`}>
              <div className="text-24 text-semibold">Join SKILENT</div>
              <div className="text-12 text-thin">
                Connect with opportunities that match your skills and aspirations
              </div>
            </div>
            <div>
              <div className="text-18 text-semibold">I'm looking to...</div>
              <div className={`${classes.radioWrapper} d-flex column`}>
                {radiobtns.map(values => {
                  return (
                    <SignUpRadio
                      key={values.title}
                      title={values.title}
                      onChange={this.changeSelectedOption}
                      checked={values.value === selectedOption}
                      value={values.value}
                      subtitle={values.subtitle}
                    />
                  )
                })}
              </div>
            </div>
            <div className={`d-flex ${classes.iconBlocksWrapper}`}>
              {icons[selectedOption].map((el, j) => (
                <div className={classes.iconBlock} key={j}>
                  {el.icon}
                  <p className={'text-14 text-bold text-dark'}>{el.name}</p>
                  <div className={'text-14  '}>{el.text}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={`${classes.form} flex-center-justify column`}>
            <div className={`${classes.formTitle} text-18 text-semibold text-dark`}>
              {selectedOption === StateSignUp.Manager && 'Sign up as Hiring manager'}
              {selectedOption === StateSignUp.Recruiter && 'Sign up as Recruiter'}
              {selectedOption === StateSignUp.Candidate && 'Sign up as Candidate'}
            </div>

            <div className={`${classes.name} d-flex`}>
              <FieldInput
                name="firstName"
                type="text"
                component={Input}
                title="First name"
                normalize={upper}
                placeholder="Enter your name.."
                required
              />
              <FieldInput
                name="lastName"
                type="text"
                component={Input}
                title="Last name"
                normalize={upper}
                placeholder="Enter last name.."
                required
              />
            </div>
            <FieldInput
              name="email"
              type="text"
              component={Input}
              title="Email"
              placeholder="email@example.com"
              required
            />
            {selectedOption === StateSignUp.Candidate && (
              <FieldSelect
                name="country"
                title="Country"
                component={Select}
                isSearchable={false}
                options={countryOptions}
                isMulti={false}
                required
              />
            )}
            <FieldInput
              name="password"
              type="password"
              component={Input}
              title="Password"
              placeholder="must include at least 8 symbols"
              isPassword={true}
              required
            />
            <FieldInput
              name="confirmationPassword"
              type="password"
              component={Input}
              title="Repeat password"
              isPassword={true}
              placeholder="must include at least 8 symbols"
              required
            />
            <FieldCheckBox
              name="accept"
              component={CheckBox}
              required
              label={
                <span className={`${classes.linkText} text-main text-14`}>
                  I accept{' '}
                  <a className="text-main text-16" href="/terms_and_conditions" target="_blank">
                    Terms and Conditions
                  </a>
                </span>
              }
            />
            <div className={classes.buttonGroup}>
              <Button fill onClick={this.logIn} label="LOG IN" variant="outlined" />
              <Button type="submit" disabled={modalIsLoading} fill label="CREATE ACCOUNT" />
            </div>
          </div>
        </div>
      </form>
    )
  }
}

export default compose<ComposeType<Props>>(
  connect(
    (state: StateInterface) => ({
      modalIsLoading: modalIsLoadingSelector(state),
      stateFromLocation: stateRouter(state),
      favoriteJobs: jobsFavoriteSelector(state).toArray()
    }),
    {
      signUpCandidate: A.signUpCandidate,
      signUpManager: A.signUpManager,
      signUpRecruiter: A.signUpRecruiter,
      push
    }
  ),
  reduxForm({
    form: 'sign-up',
    validate: signUpValidate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  }),
  injectSheet(sheet)
)(SignUp)
